import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue';

import {
  ButtonIconContextual,
  BadgeCounterFoundation
} from '@warrenbrasil/nebraska-web';

import { NotificationCentral } from '@/modules/common/components/NotificationCentral';
import { getNotificationsCounter } from '@/modules/common/services/new-notifications';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsButton',
  setup(__props) {

const notificationsCounter = ref<number>(0);
const showNotificationsCentral = ref<boolean>(false);

onBeforeMount(async () => {
  await fetchNotificationsCounter();
});

const openNotificationCentral = () => {
  showNotificationsCentral.value = true;
};

const clearUnread = () => {
  notificationsCounter.value = 0;
};

const fetchNotificationsCounter = async () => {
  try {
    const data = await getNotificationsCounter();
    notificationsCounter.value = data.pendingReads;
  } catch (error) {
    console.log(error);
  }
};

return { __sfc: true,notificationsCounter, showNotificationsCentral, openNotificationCentral, clearUnread, fetchNotificationsCounter, ButtonIconContextual, BadgeCounterFoundation, NotificationCentral }
}

})